// app/javascript/controllers/jarallax
import { Controller } from "@hotwired/stimulus"
import { jarallax } from "jarallax"

// Connects to data-controller="jarallax"
export default class extends Controller {
  connect() {
    console.log("Jarallax controller connected")

    this.element.querySelectorAll('.jarallax').forEach(container => {
      const img = container.querySelector('img')
      if (img.complete) {
        container.style.height = `${img.naturalHeight}px`
      } else {
        img.addEventListener('load', () => {
          container.style.height = `${img.naturalHeight}px`
        })
      }
    })

    jarallax(this.element.querySelectorAll('.jarallax'), {
      speed: 0.8,
      type: 'scroll',
      imgPosition: "center 10px"
    })
  }
}
